import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";

import AnalisiInfografica from "./sezione-5-Analisi-infografica";

const onShare = (popupId) => {
  const url = new URL(window.location.href);
  url.searchParams.set("popup", popupId);
  if (navigator.share) {
    navigator.share({ title: "Analisi integrata ESG", url: url.toString() }).catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url.toString()).catch(() => {});
  }
};

export default function AnalisiECG({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[1001] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Analisi integrata ESG e linee strategiche di Gruppo"
    >
      <div
        className="relative w-full md:w-[1280px] bg-[#E7E3DF] p-6 md:p-8 max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            type="button"
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
            onClick={() => onShare("AnalisiECG")}
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onClose?.(); }}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        <h2 className="text-[#3d8f30] text-[30px] md:text-[40px] font-bold leading-[1.1em]">
          Analisi integrata ESG e linee strategiche di Gruppo
        </h2>
        <p className="text-[#0E3761] text-[16px] md:text-[22px] mt-2 leading-[1.1em]">
          Le risultanze dell’analisi di doppia materialità hanno trovato concreta applicazione nella
          pianificazione strategica del Gruppo, alimentando tanto il “Piano Benefit” della Capogruppo
          – redatto ai sensi della L. 208/2015 – quanto le Linee Guida per il triennio 2026-2028.
        </p>

        {/* Nuova infografica */}
        <AnalisiInfografica />

        {/* CTA */}
        <div className="mt-8">
          <a href="https://www.realegroup.eu/groupshare/0/IT/Documents/Sostenibilit%C3%A0/2025/EXECUTIVE%20SUMMARY%202025%20(2).pdf#page=23" target="_blank" rel="noreferrer">
            <button type="button" className="ml-0 md:ml-[40%] bt-secondary2 text-sm px-4 py-2 ">
              <img src={arrowIconWhite} alt="Arrow" className="inline-block mr-2 w-[20px] h-[20px]" />
              Consulta l’Executive Summary - cap. 1
            </button>
          </a>
        </div>
      </div>
    </div>,
    document.body
  );
}
